const SERVICES = [{name : 'CAIO', link : '/cto'}, 
                  {name : 'Inteligent automation', link : '/inteligent-automatoin'}, 
                  {name : 'Data science', link : '/data-science-and-analytics'}, 
                  {name : 'Generative AI', link : '/generative-AI'}]
const COMPANY = [{name : "About us", link : "/about-us"},
                 {name : "Careers", link : "/about-us#Careers"},
                 {name : "Academy", link : "https://tenetix.academy"},
                 {name : "Privacy policy", link : "/privacy-policy"},
                 {name : "Terms of Use", link : "/terms-of-use"}]
export { SERVICES, COMPANY }